import { FC } from 'react';
import { IconProps } from './types';

const ShipIcon: FC<IconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="56.529"
      height="30.734"
      viewBox="0 0 56.529 30.734"
      className={className}
    >
      <path
        data-name="Union 44"
        d="M5.579 29.452a5.984 5.984 0 0 1-3.958-1.958A7.145 7.145 0 0 1 0 22.873v-5.248h2.979V4.767h4.6v6.213h1.956V7.945h4.006V0h3.506v7.945h5.781v5.473h-2.5v4.206H55.2L49.01 29.45l-.338.006c-10.929.185-20.913.277-28.553.277-7.704 0-13.025-.094-14.54-.281zm-4.44-6.578a6 6 0 0 0 1.353 3.884 4.91 4.91 0 0 0 3.226 1.564c2.539.312 17.98.413 42.6 0l5.005-9.559H1.139zm2.979-5.392h15.068v-5.2h2.5V9.085h-5.778V1.138H14.68v7.947h-4.006v3.035H6.439V5.907H4.118zm39.074-1.151v-4.816H50.8v4.816zm1.139-1.139h5.331v-2.538h-5.331zm-9.872 1.139v-4.816h7.609v4.816zm1.141-1.14h5.331v-2.537H35.6zm-9.872 1.139v-4.815h7.609v4.816zm1.139-1.139H32.2v-2.537h-5.334zm16.326-4.88V5.5H50.8v4.815zm1.139-1.139h5.331V6.634h-5.332zm-9.872 1.139V5.5h7.609v4.815zm1.14-1.139h5.331V6.634H35.6zm-9.872 1.139V5.5h7.609v4.815zm1.139-1.139H32.2V6.634h-5.334z"
        transform="translate(.5 .501)"
        style={{ fill: '#4780bf', stroke: 'transparent', strokeMiterlimit: 10 }}
      />
    </svg>
  );
};

export default ShipIcon;
